<template>
  <div v-if="value.organization && value.organization.logo_white" class="mb-4">
    <LogoImage
      :fit-height="50"
      :opacity="0.2"
      :value="value.organization.logo_white"
      invert
      max-height="80"
    />
  </div>

  <div class="text-h6 font-weight-light overflow-y-hidden mb-6">
    <div v-if="value.content_choice === 'Highlight' && value.highlight_content">
      <ContentBlock
        :value="value.highlight_content"
        class="text-truncate-9"
        em-class="font-weight-medium"
      />
    </div>

    <div
      v-else-if="value.content_choice === 'Testimonial' && value.testimonial"
    >
      <div
        v-if="value.testimonial.designation"
        class="text-body-2 text-uppercase mb-2"
      >
        {{ value.testimonial.designation }}
      </div>

      <div v-if="value.testimonial.quote" class="text-truncate-9">
        &ldquo;<StyledText :value="value.testimonial.quote" />&rdquo;
      </div>
    </div>
  </div>

  <div class="d-flex align-center mt-auto">
    <v-btn
      :append-icon="mdiArrowRight"
      :href="`/case-studies/${slugify(value)}`"
      class="text-none"
      color="primary"
      exact
      rounded="pill"
      size="large"
    >
      Read the Case Study
    </v-btn>
  </div>
</template>

<script setup>
import { slugify } from '#root/lib/utils'
import { mdiArrowRight } from '@mdi/js'

defineProps({
  value: {
    required: true,
    type: Object
  }
})
</script>
